import React from 'react';
import classNames from 'classnames';

import '../scss/SubHeader.scss';

const SubHeader = ({ awyesId, title, message, hasBorder = true, isError = false }) => {
  return (
    <h2 data-awyesid={awyesId} className={classNames('sub-header', {
      'sub-header--with-border': hasBorder,
      'sub-header--with-error': isError,
    })}>
      <span className="sub-header__title">{title}</span>
      <span className="sub-header__message">{message}</span>
    </h2>
  );
};

export default SubHeader;